const style = {
  label: {
    sx: {
      color: '#130F35',
    },
  },
  Box: {
    sx: {
      display: 'flex',
      gap: 3,
      pt: 2,
      '& .MuiFormControl-root': {
        flex: 1,
      },
    },
  },
  defaultStyle: {
    display: 'flex',
  },
  disabledInput: {
    pointerEvents: 'none',
    '& .css-1qzdy1m-MuiInputBase-root-MuiInput-root:before': {
      border: '0',
    },
    '& .MuiInputAdornment-root': {
      display: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0,
      padding: '0px',
    },
    '& fieldset': {
      border: '0',
      padding: '0px',
      color: 'black',
    },
    '& div[role=button]': {
      WebkitTextFillColor: 'black',
    },
  },
} as const;

export default style;
